import i18next from 'i18next';
import * as yup from 'yup';

export const getTranslate = (route: string) => {
  return i18next.t(route);
};
export const StringRequired = yup
  .string()
  .required(() => i18next.t('common.validations.fieldRequired'));
export const NumberRequired = yup
  .number()
  .nullable()
  .required(() => i18next.t('common.validations.fieldRequired'))
  .typeError(() => i18next.t('common.validations.fieldRequired'));
export const ObjectRequired = yup
  .object()
  .required(() => i18next.t('common.validations.fieldRequired'))
  .nullable();

export const DateRequired = yup
  .date()
  .required(() => i18next.t('common.validations.fieldRequired'));

export const ArrayRequired = yup
  .array()
  .required(() => i18next.t('common.validations.fieldRequired'))
  .min(1);
export const EmailRequired = yup
  .string()
  .email(() => i18next.t('common.validations.email'))
  .required(() => i18next.t('common.validations.fieldRequired'));
